var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"percentage-tag",class:{small: _vm.small}},[_c('img',{attrs:{"src":require('@/static/img/icons/ic_lightning.svg')}}),(_vm.message)?_c('div',{staticClass:"tag-label"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }